import React from 'react'
import { makeStyles, Button } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
   submitButton: {
      margin: theme.spacing(1, 0, 2, 0),
      textTransform: 'none',
      color: '#fff'
   }
}))

function SubmitButton({ text, ...props }) {
   const classes = useStyles()

   return (
      <Button
         type="submit"
         variant="contained"
         color="primary"
         className={classes.submitButton}
         fullWidth
         disableElevation
         disabled={!!props?.disabled}
         {...props}
      >
         {text}
      </Button>
   )
}

export default SubmitButton
